import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCGrayFile(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 503.2 497.91">
            <defs>
                <linearGradient
                    id="linear-gradient"
                    x1="0.5"
                    y1="0.333"
                    x2="0.5"
                    y2="1.026"
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset="0" stopColor="#fff" />
                    <stop offset="1" stopColor="#e3e2e3" />
                </linearGradient>
                <linearGradient
                    id="linear-gradient-2"
                    x1="0.504"
                    y1="0.381"
                    x2="0.471"
                    y2="1.277"
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset="0" stopColor="#e1e0f0" stopOpacity="0" />
                    <stop offset="1" stopColor="#c3c0d9" />
                </linearGradient>
                <linearGradient
                    id="linear-gradient-3"
                    x1="0.5"
                    y1="-0.106"
                    x2="0.5"
                    y2="1.171"
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset="0.48" stopColor="#e3e2e3" />
                    <stop offset="1" stopColor="#707171" />
                </linearGradient>
                <linearGradient id="linear-gradient-4" x1="0.5" y1="0.052" x2="0.5" y2="1.358" />
                <linearGradient id="linear-gradient-5" x1="0.5" y1="0.354" x2="0.5" y2="1.176" />
                <linearGradient id="linear-gradient-6" x1="0.5" y1="0.393" x2="0.5" y2="0.968" />
                <linearGradient id="linear-gradient-7" x1="-0.137" y1="0.5" x2="1.137" y2="0.5" />
                <linearGradient id="linear-gradient-8" x1="0.5" y1="0.048" x2="0.5" y2="0.975" />
            </defs>
            <g xmlns="http://www.w3.org/2000/svg" id="Files" transform="translate(-4.15 -6.15)">
                <g id="Layer_1">
                    <circle
                        id="Ellipse_9"
                        cx="225.85"
                        cy="225.85"
                        r="225.85"
                        transform="translate(8.5 7.65)"
                        fill="#fff"
                        stroke="#707171"
                        strokeMiterlimit="10"
                        strokeWidth="3"
                    />
                    <ellipse
                        id="Ellipse_10"
                        cx="117.2"
                        cy="12.33"
                        rx="117.2"
                        ry="12.33"
                        transform="translate(117.37 398.8)"
                        fill="url(#linear-gradient)"
                    />
                    <ellipse
                        id="_Path_"
                        cx="160.18"
                        cy="15.73"
                        rx="160.18"
                        ry="15.73"
                        transform="translate(75.43 472.6)"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_120"
                        d="M235.76,96.33a41.37,41.37,0,0,0-58.42,0,2.36,2.36,0,0,0,3.33,3.34,36.64,36.64,0,0,1,51.76,0,2.36,2.36,0,0,0,3.33-3.34Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_121"
                        d="M184.76,103.75a2.36,2.36,0,0,0,3.33,3.34,26.14,26.14,0,0,1,36.92,0,2.36,2.36,0,1,0,3.33-3.34,30.86,30.86,0,0,0-43.58,0Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_122"
                        d="M192.22,111.22a2.362,2.362,0,1,0,3.34,3.34,15.56,15.56,0,0,1,22,0,2.362,2.362,0,0,0,3.34-3.34,20.29,20.29,0,0,0-28.68,0Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_123"
                        d="M202.9,116.53a6.53,6.53,0,1,0,9.24,0,6.53,6.53,0,0,0-9.24,0Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_124"
                        d="M54.39,177.19a24,24,0,1,0,24,24,24,24,0,0,0-24-24Zm0,41a16.983,16.983,0,1,0,0-.03Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_125"
                        d="M104.62,209.26V193.11H96.93a42.521,42.521,0,0,0-1.66-6.2l6.66-3.85-8.08-14-6.67,3.85a42.119,42.119,0,0,0-4.53-4.53l3.85-6.67-14-8.08-3.85,6.66a42.518,42.518,0,0,0-6.2-1.66V151H46.31v7.69a42.524,42.524,0,0,0-6.2,1.66l-3.85-6.66-14,8.08,3.85,6.67a43.052,43.052,0,0,0-4.53,4.53l-6.67-3.85-8.08,14,6.66,3.85a42.521,42.521,0,0,0-1.66,6.2H4.15v16.15h7.69a42.52,42.52,0,0,0,1.66,6.2l-6.66,3.85,8.08,14,6.67-3.85A44,44,0,0,0,26.12,234l-3.85,6.67,14,8.08,3.85-6.66a42.518,42.518,0,0,0,6.2,1.66v7.69H62.46v-7.69a42.52,42.52,0,0,0,6.2-1.66l3.85,6.66,14-8.08L82.65,234a43.051,43.051,0,0,0,4.53-4.53l6.67,3.85,8.08-14-6.66-3.85a42.522,42.522,0,0,0,1.66-6.2Zm-50.23,24a116.023,116.023,0,1,1-.007.01Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_126"
                        d="M285.93,39.79a10.43,10.43,0,1,0,10.43,10.43A10.43,10.43,0,0,0,285.93,39.79Zm0,17.81a7.38,7.38,0,1,1,7.38-7.38A7.38,7.38,0,0,1,285.93,57.6Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_127"
                        d="M307.76,53.73v-7h-3.34A18.69,18.69,0,0,0,303.7,44l2.89-1.67-3.51-6.08-2.9,1.67a17.45,17.45,0,0,0-2-2l1.68-2.9-6.09-3.51L292.1,32.4a20.08,20.08,0,0,0-2.69-.72v-3.3h-7v3.34a19.83,19.83,0,0,0-2.7.72l-1.67-2.89L272,33.06l1.67,2.9a19.278,19.278,0,0,0-2,2l-2.9-1.67-3.51,6.08L268.15,44a20.082,20.082,0,0,0-.72,2.69h-3.34v7h3.34a20.078,20.078,0,0,0,.72,2.69l-2.89,1.67,3.51,6.09,2.9-1.68a19.278,19.278,0,0,0,2,2L272,67.37l6.08,3.51L279.72,68a19.831,19.831,0,0,0,2.7.72v3.34h7V68.71a20.079,20.079,0,0,0,2.69-.72l1.67,2.89,6.09-3.51-1.68-2.9a17.452,17.452,0,0,0,2-2l2.9,1.68,3.51-6.09-2.89-1.67a18.7,18.7,0,0,0,.72-2.69ZM285.93,64.16a13.95,13.95,0,1,1,13.94-13.943A13.95,13.95,0,0,1,285.93,64.16Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_128"
                        d="M348.19,347.21a18.34,18.34,0,1,0,18.35,18.343,18.34,18.34,0,0,0-18.35-18.343Zm0,31.32a13,13,0,1,1,13-13A13,13,0,0,1,348.19,378.53Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_129"
                        d="M386.6,371.73V359.37h-5.88a33.1,33.1,0,0,0-1.27-4.74l5.09-2.94L378.37,341l-5.1,2.94a33.434,33.434,0,0,0-3.47-3.47l2.94-5.09-10.69-6.18-2.94,5.09a34.461,34.461,0,0,0-4.74-1.27v-5.88H342V333a34.456,34.456,0,0,0-4.74,1.27l-2.93-5.09-10.7,6.18,2.94,5.09a32.39,32.39,0,0,0-3.46,3.47L318,341l-6.18,10.69,5.09,2.94a34.459,34.459,0,0,0-1.27,4.74h-5.88v12.36h5.88a34.461,34.461,0,0,0,1.27,4.74l-5.09,2.93L318,390.1l5.1-2.94a31.393,31.393,0,0,0,3.46,3.46l-2.94,5.1,10.7,6.18,2.93-5.09a34.455,34.455,0,0,0,4.74,1.27V404h12.36v-5.88a34.455,34.455,0,0,0,4.74-1.27l2.94,5.09,10.69-6.18-2.94-5.1a32.39,32.39,0,0,0,3.47-3.46l5.1,2.94,6.17-10.7-5.09-2.93a33.1,33.1,0,0,0,1.27-4.74Zm-38.41,18.35a24.53,24.53,0,1,1,24.53-24.53A24.53,24.53,0,0,1,348.19,390.08Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_130"
                        d="M430.49,347.3c-1.39.41-2.81.8-4.22,1.19-6.93,1.92-14,3.9-19.26,8.81-1,.91-1.94,1.9-2.92,2.89a62.535,62.535,0,0,1-8.55.21q-2.78-.11-5.55-.46a72.526,72.526,0,0,1-7.7-1.34c1.27-7.19,5.06-15.83,5.69-19.32,1.69-9.36-1.89-19.36,1.6-28.25,4.22-10.66,17.4-16.24,20-27.38,2.29-9.75-4.51-20.42-.12-29.43,3.93-8.06,14.26-9.8,21.34-15.17,13-9.84,12.87-29.75,22.08-43.36a33.46,33.46,0,0,1,16.61-12.56c8-2.79,16.83-2.59,24.1,1.48,13.28,7.45,18.19,27.46,9.17,40.35-6.43,9.2-18.4,14.5-21.52,25.26-2.95,10.15,3.29,21.55-1.13,31.15-2.8,6.1-9,9.42-14.35,13.52a33.12,33.12,0,0,0-5.28,4.88C447.51,315.3,454.12,340.3,430.49,347.3Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_131"
                        d="M468.88,281.6l-.6.19a116.85,116.85,0,0,0-29.46,13.9q-10.85,19.2-23.33,37.46a172.1,172.1,0,0,1,19.45-8.08c2.83-1,4.47,3.39,1.64,4.36a169.053,169.053,0,0,0-26.79,11.88q-6.9,9.69-14.25,19.09-2.78-.11-5.55-.46c13.06-16.71,25.22-34.71,28.07-39.08a2.31,2.31,0,0,1-.27-1.31A55.43,55.43,0,0,0,413.33,294c-1.18-2.75,3.18-4.38,4.36-1.63A59.86,59.86,0,0,1,422.47,314c4-6.37,18.34-31.56,21-36.63a155.659,155.659,0,0,0-10.33-31.91c-1.21-2.76,3.14-4.38,4.35-1.64A160.261,160.261,0,0,1,446.73,271a517.766,517.766,0,0,0,21.2-48q-3.76-8-7.5-16c-1.29-2.7,3.08-4.33,4.35-1.62l4.05,8.6,1.37,2.91c1.27-3.5,2.54-7,3.75-10.52,1-2.84,5.32-1.15,4.34,1.68-1.21,3.56-5.75,15.55-8.9,23.7-1.24,3.21-2.27,5.83-2.8,7.1,1-.82,1.94-1.64,3-2.42a113.053,113.053,0,0,1,17.74-11.6c2.64-1.4,4.26,3,1.63,4.36a105.341,105.341,0,0,0-19.2,13.06c-2,1.68-3.89,3.45-5.75,5.28a2.33,2.33,0,0,1-1.38.69q-8.77,20-19.21,39.21a120.579,120.579,0,0,1,23.86-10.23,2.3,2.3,0,0,1,1.58,0C470.59,278,471.15,280.9,468.88,281.6Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_132"
                        d="M24.44,231a27.84,27.84,0,0,0,11.88,16.5l2.25,3.5a37.4,37.4,0,0,0-19.75-.45,27.86,27.86,0,0,0,20.42,1.53q2.09,3.27,4.7,7.52l2.5,4.09c.41.68.82,1.37,1.23,2.08a48.5,48.5,0,0,0-28.56,2.61A36.49,36.49,0,0,0,48,266.27l1.1,1.88c1.85,3.07,3.66,6.39,5.63,9.87.86,1.58,1.73,3.2,2.61,4.84-11.11-3.56-23.18-3.19-34.37.07a44.27,44.27,0,0,0,35.16,1.42c2,3.85,4.08,7.86,6.11,12v.2l.08-.08q1,2.13,2.08,4.3c.07.14.13.28.2.43A50,50,0,0,0,27.75,303c12.82,4.29,26.74,3.81,39.6-.09,3.36,7.28,6.29,14.18,8.79,20.48.2.52.4,1,.59,1.55-14-8.19-32.1-10.24-47.31-5.24,14.71,7.43,31.64,9.17,47.81,6.53.92,2.42,1.82,4.74,2.56,6.92.54,1.52,1.09,3,1.57,4.41s.91,2.74,1.33,4v.11a57.384,57.384,0,0,0-45.33.33c14.68,5.43,30.82,5.32,45.83,1.2,3,9.27,4.44,14.82,4.91,15.07.3.17-.19-3.71-2-10.76,11.68-5.29,21.09-14.66,27.47-25.73a46.65,46.65,0,0,0-27.78,24.54c-.29-1.13-.61-2.32-1-3.59h.11l-.13-.06-.06-.21c-.37-1.28-.76-2.63-1.17-4s-.93-2.9-1.43-4.44c-.17-.54-.36-1.11-.54-1.67,13.53-8.87,23.5-22.33,29.45-37.32a59.76,59.76,0,0,0-30.25,35c-.67-1.9-1.39-3.88-2.13-5.92-1-2.62-2.07-5.36-3.23-8.18,11.86-11.29,19.27-26.53,22.34-42.54a59.77,59.77,0,0,0-23.22,40.43q-2.6-6.21-5.72-12.9c-1-2-1.92-4-2.89-5.93,10-8.83,16.66-20.94,19.91-33.85A50.18,50.18,0,0,0,64.7,292.57c-2.33-4.58-4.69-9-7-13.13a44.19,44.19,0,0,0,7.89-33.84,57.21,57.21,0,0,0-9.31,31.32c-1.92-3.3-3.73-6.45-5.56-9.36-1-1.56-1.89-3.08-2.8-4.52l-1.16-1.76a22.79,22.79,0,0,0,6.44-20.94,29.16,29.16,0,0,0-7.38,19.49l-.59-.9c-1.8-2.73-3.46-5.16-4.93-7.25h-.06l-.68-1a27.83,27.83,0,0,0,1.17-20.28,35.92,35.92,0,0,0-2.3,18.71c-.5-.7-1-1.34-1.4-1.93A37.09,37.09,0,0,0,24.44,231Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_133"
                        d="M146,401.05c2.84,2.08,6.43,2.83,9.9,3.38a127.8,127.8,0,0,0,52.41-2.53c.92-.23,1.83-.48,2.75-.75l.22-.92.06-.15,1-4,7.74-30.21a97.42,97.42,0,0,0-2-53.15c-2.46-7.45-6.11-15-12.59-19.37s-16.38-4.57-21.38,1.48c-3,3.63-3.71,8.6-4,13.3a117.68,117.68,0,0,0,5.77,44.51,54.85,54.85,0,0,0-26.25-25.95c-7.66-3.55-18.1-4.65-23.4,1.93-2.83,3.49-3.4,8.41-2.36,12.77s3.48,8.27,6.17,11.86a82,82,0,0,0,33.25,26,57.56,57.56,0,0,0-24.45,6.3c-2.78,1.42-5.64,3.33-6.56,6.3C141.19,395.27,143.12,399,146,401.05Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_134"
                        d="M147.08,348.23l12.31-.5q9.51,9.58,19,19.16l-10,1.06c-2,.21-1.87,3.37.15,3.16,4.23-.46,8.47-.9,12.71-1.35l25.63,25.85c-2.87-.26-5.73-.52-8.58-.76a1,1,0,0,1-.11-.17q-4.75-4.76-9.47-9.51c-1.42-1.45-3.52.92-2.08,2.36l6.83,6.89c-7-.62-14-1.25-21.06-1.85-1.54-2.07-3.1-4.12-4.64-6.2-1.23-1.6-3.87.13-2.64,1.75,1,1.36,2,2.71,3,4.07l-3.87-.34c-2-.18-2.69,2.91-.67,3.08l16.95,1.5-4.38,3.77a1.58,1.58,0,0,0-1.59,1.6c0,.18,0,.36,0,.55a1.6,1.6,0,0,0,2.45,1.24q4-3.39,7.87-6.77l23,2,.37,3c.92-.23,1.83-.48,2.75-.75l.22-.92v-.21l.07.06,1-4-.31-.07h-.31l-1.09-1.1-2.9-24a1.75,1.75,0,0,0,.59-.54l6-9.13c1.12-1.7-1.7-3.11-2.82-1.44-1.45,2.21-2.89,4.41-4.35,6.6q-1.59-13-3.16-26.09l.05-.07q4.88-6.34,9.71-12.7c1.24-1.6-1.11-3.7-2.36-2.08l-7.94,10.37q-1.33-11.16-2.7-22.34c-.25-2-3.41-1.86-3.16.15l.63,5.22-8.68-4c-1.85-.84-3.29,2-1.43,2.83,3.52,1.61,7,3.21,10.55,4.84l3.21,26.56c-3.07-2.12-6.16-4.23-9.24-6.35-1.66-1.13-3.78,1.23-2.1,2.37l11.28,7.72a1.23,1.23,0,0,0,.56.25q2.31,19.13,4.63,38.22l-11.53-11.61a1.16,1.16,0,0,0,.07-.44c-.23-5.26-.44-10.53-.67-15.79a1.582,1.582,0,0,0-3.16.15l.55,12.84-20.79-21a.84.84,0,0,0,0-.39q-.81-5.71-1.62-11.47c-.29-2-3.45-1.85-3.16.15.39,2.69.77,5.37,1.15,8.06q-5.25-5.29-10.49-10.59c-1.44-1.45-3.53.94-2.1,2.36.35.37.72.73,1.07,1.1l-9.43.4a1.624,1.624,0,1,0,.23,3.24Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_135"
                        d="M324.21,401.05c-2.84,2.08-6.43,2.83-9.91,3.38a127.75,127.75,0,0,1-52.4-2.53c-.92-.23-1.84-.48-2.75-.75l-.23-.92-.05-.15-1-4-7.75-30.21a97.42,97.42,0,0,1,2-53.15c2.46-7.45,6.11-15,12.59-19.37s16.38-4.57,21.38,1.48c3,3.63,3.71,8.6,4,13.3a117.471,117.471,0,0,1-5.76,44.51,54.88,54.88,0,0,1,26.24-25.95c7.67-3.55,18.1-4.65,23.41,1.93,2.83,3.49,3.39,8.41,2.36,12.77s-3.48,8.27-6.17,11.86a82.05,82.05,0,0,1-33.25,26,57.63,57.63,0,0,1,24.45,6.3c2.77,1.42,5.64,3.33,6.56,6.3C329,395.27,327.06,399,324.21,401.05Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_136"
                        d="M323.1,348.23l-12.3-.5q-9.51,9.58-19,19.16l10,1.06c2,.21,1.87,3.37-.16,3.16-4.22-.46-8.46-.9-12.71-1.35l-25.62,25.85c2.86-.26,5.72-.52,8.58-.76a.59.59,0,0,0,.1-.17q4.75-4.76,9.48-9.51c1.42-1.45,3.52.92,2.08,2.36l-6.83,6.89c7-.62,14-1.25,21.06-1.85,1.54-2.07,3.09-4.12,4.64-6.2,1.23-1.6,3.87.13,2.63,1.75l-3,4.07,3.87-.34c2-.18,2.68,2.91.67,3.08l-17,1.5c1.47,1.26,2.93,2.53,4.39,3.77a1.57,1.57,0,0,1,1.58,1.6v.55a1.58,1.58,0,0,1-2.45,1.24l-7.87-6.77-23,2-.37,3c-.92-.23-1.84-.48-2.75-.75l-.23-.92a1.646,1.646,0,0,0,0-.21l-.07.06-1-4,.3-.07a2.984,2.984,0,0,0,.31,0l1.1-1.1,2.9-24a1.67,1.67,0,0,1-.59-.54l-6-9.13c-1.13-1.7,1.7-3.11,2.81-1.44l4.35,6.6q1.59-13,3.16-26.09v-.07q-4.87-6.34-9.72-12.7c-1.23-1.6,1.12-3.7,2.37-2.08l7.93,10.37q1.35-11.16,2.71-22.34c.25-2,3.4-1.86,3.16.15l-.63,5.22,8.67-4c1.86-.84,3.29,2,1.43,2.83-3.52,1.61-7,3.21-10.54,4.84l-3.22,26.56,9.25-6.35c1.65-1.13,3.77,1.23,2.1,2.37l-11.28,7.72a1.28,1.28,0,0,1-.56.25q-2.31,19.13-4.63,38.22l11.53-11.61a1.38,1.38,0,0,1-.08-.44q.35-7.89.68-15.79a1.582,1.582,0,1,1,3.16.15l-.56,12.84,20.8-21a.73.73,0,0,1,0-.39q.79-5.71,1.61-11.47c.3-2,3.45-1.85,3.16.15l-1.14,8.06q5.25-5.29,10.49-10.59c1.43-1.45,3.53.94,2.1,2.36l-1.08,1.1,9.43.4a1.623,1.623,0,0,1-.2,3.24Z"
                        fill="#f4f5f6"
                    />
                    <rect
                        id="Rectangle_89"
                        width="313.51"
                        height="208.08"
                        rx="9.01"
                        transform="translate(78.68 149.88)"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_90"
                        width="184.19"
                        height="287.51"
                        rx="2.25"
                        transform="translate(378.32 163.45) rotate(90)"
                        fill="#fff"
                    />
                    <rect
                        id="Rectangle_91"
                        width="49.85"
                        height="41.36"
                        transform="translate(210.52 357.96)"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_92"
                        width="110.82"
                        height="7.81"
                        transform="translate(180.03 399.32)"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_93"
                        width="49.85"
                        height="17"
                        transform="translate(210.52 357.96)"
                        fill="#fff"
                        opacity="0.14"
                    />
                    <path
                        id="Path_137"
                        d="M344.55,211.62a41.6,41.6,0,0,1-4.18-.14.581.581,0,1,1,.08-1.16c1.9.13,3.84.17,5.76.12a.62.62,0,0,1,.6.56.58.58,0,0,1-.57.6C345.68,211.62,345.12,211.62,344.55,211.62Zm7.47-.44a.57.57,0,0,1-.57-.52A.58.58,0,0,1,352,210c1.89-.23,3.8-.54,5.68-.93a.57.57,0,0,1,.69.44.58.58,0,0,1-.45.69c-1.91.4-3.86.72-5.79.95Zm-17.38-.39h-.1a56.535,56.535,0,0,1-5.72-1.3.58.58,0,0,1-.4-.72.57.57,0,0,1,.71-.4,54.372,54.372,0,0,0,5.61,1.27.58.58,0,0,1,.48.67.59.59,0,0,1-.58.48Zm28.75-2a.57.57,0,0,1-.55-.41.58.58,0,0,1,.39-.73c1.82-.55,3.65-1.19,5.44-1.89a.57.57,0,0,1,.75.32.58.58,0,0,1-.32.76c-1.82.72-3.68,1.37-5.54,1.93Zm-39.91-1.19a.57.57,0,0,1-.22,0A49.761,49.761,0,0,1,318,205a.58.58,0,0,1,.57-1,50.174,50.174,0,0,0,5.17,2.49.58.58,0,0,1-.22,1.12Zm50.71-3.1a.59.59,0,0,1-.52-.32.57.57,0,0,1,.26-.78l.94-.48c1.38-.72,2.76-1.5,4.1-2.31a.586.586,0,0,1,.61,1c-1.37.83-2.77,1.62-4.17,2.35l-1,.49a.58.58,0,0,1-.22.06Zm9.94-6a.57.57,0,0,1-.47-.24.58.58,0,0,1,.14-.81c1.54-1.1,3.09-2.28,4.58-3.51a.58.58,0,1,1,.74.89c-1.52,1.25-3.08,2.45-4.65,3.57a.59.59,0,0,1-.34.1Zm9-7.37a.58.58,0,0,1-.42-.18.59.59,0,0,1,0-.83c1.38-1.29,2.76-2.67,4.09-4.08a.57.57,0,0,1,.82,0,.59.59,0,0,1,0,.83c-1.35,1.43-2.74,2.82-4.14,4.13a.55.55,0,0,1-.37.13Zm83.58-.62h-.45a.59.59,0,0,1-.56-.6.6.6,0,0,1,.6-.57h.43Zm-6.19-.75h-.12a33.539,33.539,0,0,1-5.64-1.78.57.57,0,0,1-.32-.75.59.59,0,0,1,.76-.32,32.742,32.742,0,0,0,5.45,1.71.59.59,0,0,1,.44.7.58.58,0,0,1-.59.44Zm-10.71-4.39a.55.55,0,0,1-.3-.09,35.563,35.563,0,0,1-4.74-3.53.581.581,0,0,1,.77-.87,34.667,34.667,0,0,0,4.58,3.41.584.584,0,0,1-.33,1.08Zm-58.71-2.7a.54.54,0,0,1-.37-.14.57.57,0,0,1-.07-.82c1.21-1.45,2.42-3,3.59-4.53a.57.57,0,0,1,.81-.11.58.58,0,0,1,.12.81c-1.18,1.57-2.4,3.11-3.63,4.58a.58.58,0,0,1-.47.21Zm50-5a.55.55,0,0,1-.45-.22,33.131,33.131,0,0,1-3.29-4.91.58.58,0,0,1,.24-.79.57.57,0,0,1,.78.23,31.579,31.579,0,0,0,3.17,4.74.619.619,0,0,1-.43.98Zm-43.06-4.32a.63.63,0,0,1-.32-.1.58.58,0,0,1-.16-.81c1.07-1.58,2.12-3.22,3.12-4.88a.58.58,0,0,1,.8-.19.59.59,0,0,1,.2.8c-1,1.67-2.08,3.32-3.15,4.92a.59.59,0,0,1-.47.29Zm37.52-5.84a.59.59,0,0,1-.55-.39c-.62-1.78-1.15-3.63-1.67-5.42l-.05-.16a.584.584,0,0,1,1.12-.33l.05.17c.51,1.77,1,3.61,1.65,5.36a.57.57,0,0,1-.36.74.631.631,0,0,1-.17.06Zm-31.48-4.1a.72.72,0,0,1-.28-.07.59.59,0,0,1-.23-.79l1-1.93c.55-1.06,1.09-2.13,1.61-3.21a.58.58,0,0,1,.78-.27.57.57,0,0,1,.27.77c-.53,1.1-1.07,2.18-1.64,3.25-.34.65-.69,1.3-1,1.94a.56.56,0,0,1-.49.34Zm28-7a.58.58,0,0,1-.55-.39,31.822,31.822,0,0,0-2.34-5.2.58.58,0,1,1,1-.58,31.722,31.722,0,0,1,2.43,5.39.58.58,0,0,1-.35.74.431.431,0,0,1-.13.07Zm-23.05-3.5a.52.52,0,0,1-.21,0,.58.58,0,0,1-.33-.75,51.68,51.68,0,0,0,1.79-5.46.583.583,0,1,1,1.13.29,53.35,53.35,0,0,1-1.83,5.59.58.58,0,0,1-.49.36Zm17.1-6.36a.59.59,0,0,1-.4-.16,22.28,22.28,0,0,0-4.56-3.35.58.58,0,0,1,.57-1,23.372,23.372,0,0,1,4.79,3.53.58.58,0,0,1,0,.82.59.59,0,0,1-.34.19ZM422,141.71h-.07a.58.58,0,0,1-.51-.65c0-.47.09-.94.12-1.4l-1.08-.2a.57.57,0,0,1-.48-.66.56.56,0,0,1,.66-.48l1,.16v-.85a18.813,18.813,0,0,0-.09-2.26.58.58,0,0,1,.53-.63.6.6,0,0,1,.63.54c.06.77.09,1.56.09,2.35v1.09a35.647,35.647,0,0,1,3.63,1,.58.58,0,0,1-.36,1.1c-1.06-.34-2.18-.65-3.33-.91a11.216,11.216,0,0,1-.12,1.3.57.57,0,0,1-.62.5Zm-24.67-2.5a.58.58,0,0,1,0-1.16c1.93,0,3.87-.1,5.8-.18a.62.62,0,0,1,.6.56.6.6,0,0,1-.56.61c-1.94.07-3.88.15-5.82.17Zm-5.81-.12h0a46.392,46.392,0,0,1-5.84-.71.59.59,0,0,1-.47-.68.58.58,0,0,1,.68-.46,46.268,46.268,0,0,0,5.7.69.59.59,0,0,1,.55.62.58.58,0,0,1-.63.54Zm23.25-.2h0c-1.78-.08-3.77-.09-5.78,0a.58.58,0,1,1,0-1.16h5.85a.58.58,0,0,1,0,1.16Zm-34.64-2a.43.43,0,0,1-.19,0,28.181,28.181,0,0,1-5.36-2.53.586.586,0,1,1,.61-1,27.39,27.39,0,0,0,5.14,2.43.58.58,0,0,1,.35.74.59.59,0,0,1-.56.37Zm-9.75-6.13a.56.56,0,0,1-.42-.18c-.13-.13-.25-.26-.37-.4a17.241,17.241,0,0,1-2.94-4.59.58.58,0,0,1,1.06-.47,16.2,16.2,0,0,0,2.74,4.29l.35.37a.58.58,0,0,1-.42,1ZM421,130.2a.57.57,0,0,1-.56-.42,29.33,29.33,0,0,0-2.17-5.26.58.58,0,1,1,1-.54,29.6,29.6,0,0,1,2.25,5.47.59.59,0,0,1-.39.73Zm-55.33-9.85a.59.59,0,0,1-.58-.53,17,17,0,0,1,.48-6,.6.6,0,0,1,.72-.41.58.58,0,0,1,.4.72,14.669,14.669,0,0,0-.52,4,10.6,10.6,0,0,0,.08,1.59.59.59,0,0,1-.53.64Zm49.95-.39a.58.58,0,0,1-.46-.22,34.9,34.9,0,0,0-3.89-4.18.581.581,0,0,1,.78-.86,35.742,35.742,0,0,1,4,4.32.6.6,0,0,1-.1.82.62.62,0,0,1-.3.16Zm-8.57-7.79a.61.61,0,0,1-.31-.09,39.748,39.748,0,0,0-5-2.76.58.58,0,0,1,.49-1,41.241,41.241,0,0,1,5.16,2.83.58.58,0,0,1-.32,1.07Zm-38.17-2.64a.54.54,0,0,1-.39-.16.58.58,0,0,1,0-.82,13.251,13.251,0,0,1,1.15-1.1,14,14,0,0,1,3.85-2.26.581.581,0,1,1,.43,1.08,12.58,12.58,0,0,0-3.53,2.07,10.937,10.937,0,0,0-1,1,.59.59,0,0,1-.48.19Zm27.66-2.23a.57.57,0,0,1-.18,0,49.821,49.821,0,0,0-5.57-1.39.58.58,0,1,1,.21-1.14,52.339,52.339,0,0,1,5.71,1.42.58.58,0,0,1,.38.73.59.59,0,0,1-.52.38Zm-11.4-2.18h-.3a33.32,33.32,0,0,0-5.46,0,.582.582,0,1,1-.1-1.16,34.522,34.522,0,0,1,5.65,0h.25a.58.58,0,1,1,0,1.16Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_138"
                        d="M450.62,408.67l.16.07c.4.19.85.58.56,1.07a1.39,1.39,0,0,1-.67.52,9.26,9.26,0,0,1-2.84.71,7,7,0,0,1-3.16-.14c-1-.39-.84-1.58.14-2A7.84,7.84,0,0,1,450.62,408.67Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_139"
                        d="M450.62,412.45l.16.07c.4.18.85.58.56,1.07a1.44,1.44,0,0,1-.67.51,9,9,0,0,1-2.84.71,6.75,6.75,0,0,1-3.16-.14c-1-.38-.84-1.58.14-2A7.84,7.84,0,0,1,450.62,412.45Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_140"
                        d="M406.81,166.51h0c0,.47-.05,11.74,10.14,14.73,10.38,3.06,25.49-14.81,25.49-14.81l-4.9-2.27c-3.14,4-12.66,15.44-18.94,14.17-5.43-1.09-8.28-8.55-9.47-12.72l-.38.15-1.29.5Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_141"
                        d="M469.44,221.3l-.21,6.15-24.01-3.82.02-6.36Z"
                        fill="#fff"
                    />
                    <rect
                        id="Rectangle_94"
                        width="37.67"
                        height="37.67"
                        rx="4.06"
                        transform="translate(80.679 83.076) rotate(27.34)"
                        fill="url(#linear-gradient-2)"
                    />
                    <rect
                        id="Rectangle_95"
                        width="37.67"
                        height="37.67"
                        rx="4.06"
                        transform="translate(85.784 81.733) rotate(27.34)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_96"
                        width="18.45"
                        height="16.4"
                        rx="2.23"
                        transform="translate(85.643 93.633) rotate(27.34)"
                        fill="#fff"
                    />
                    <path
                        id="Path_142"
                        d="M108.38,104.53l-12.07,3.84,3.84,12.07a1.05,1.05,0,0,0,1.94.16l7.54-14.6a1,1,0,0,0-1.25-1.47Z"
                        fill="#fff"
                    />
                    <rect
                        id="Rectangle_97"
                        width="287.51"
                        height="23.29"
                        transform="translate(90.57 161.83)"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_98"
                        width="287.51"
                        height="23.29"
                        transform="translate(90.57 161.83)"
                        fill="#fff"
                        opacity="0.2"
                    />
                    <circle
                        id="Ellipse_11"
                        cx="4.24"
                        cy="4.24"
                        r="4.24"
                        transform="translate(326.23 169.24)"
                        fill="#f4f5f6"
                    />
                    <circle
                        id="Ellipse_12"
                        cx="4.24"
                        cy="4.24"
                        r="4.24"
                        transform="translate(343.29 169.24)"
                        fill="#f4f5f6"
                    />
                    <circle
                        id="Ellipse_13"
                        cx="4.24"
                        cy="4.24"
                        r="4.24"
                        transform="translate(360.36 169.24)"
                        fill="#f4f5f6"
                    />
                    <rect
                        id="Rectangle_99"
                        width="86.24"
                        height="88.94"
                        rx="3.69"
                        transform="translate(101.11 175.09)"
                        fill="url(#linear-gradient-3)"
                    />
                    <rect
                        id="Rectangle_100"
                        width="86.24"
                        height="88.94"
                        rx="3.69"
                        transform="translate(104.2 171.45)"
                        fill="#fff"
                    />
                    <rect
                        id="Rectangle_101"
                        width="59.21"
                        height="7.69"
                        transform="translate(110.42 177.56)"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_143"
                        d="M184.22,184.16l-1.76-1.76a3,3,0,1,0-.85.86l1.75,1.75ZM178.65,182a1.84,1.84,0,0,1,0-2.57,1.82,1.82,0,1,1,0,2.57Z"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_102"
                        width="39.29"
                        height="3.8"
                        transform="translate(110.42 195.46)"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_103"
                        width="57.07"
                        height="3.8"
                        transform="translate(110.42 203.39)"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_104"
                        width="64.95"
                        height="3.8"
                        transform="translate(110.42 239.47)"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_105"
                        width="30.95"
                        height="3.8"
                        transform="translate(110.42 247.62)"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_106"
                        width="66.53"
                        height="3.8"
                        transform="translate(117.69 213.2)"
                        fill="#e3e2e3"
                    />
                    <circle
                        id="Ellipse_14"
                        cx="1.77"
                        cy="1.77"
                        r="1.77"
                        transform="translate(110.42 213.34)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_107"
                        width="66.53"
                        height="3.8"
                        transform="translate(117.69 221.35)"
                        fill="#e3e2e3"
                    />
                    <circle
                        id="Ellipse_15"
                        cx="1.77"
                        cy="1.77"
                        r="1.77"
                        transform="translate(110.42 221.48)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_108"
                        width="66.53"
                        height="3.8"
                        transform="translate(117.69 229.5)"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_144"
                        d="M114,231.4a1.77,1.77,0,1,1-1.76-1.77A1.77,1.77,0,0,1,114,231.4Z"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_109"
                        width="96.58"
                        height="65.34"
                        rx="2.94"
                        transform="translate(305.3 300.21)"
                        fill="url(#linear-gradient-4)"
                    />
                    <rect
                        id="Rectangle_110"
                        width="96.58"
                        height="65.34"
                        rx="2.94"
                        transform="translate(307.97 296.81)"
                        fill="#f4f5f6"
                    />
                    <rect
                        id="Rectangle_111"
                        width="84.95"
                        height="7.93"
                        transform="translate(313.79 347.91)"
                        fill="#fff"
                    />
                    <rect
                        id="Rectangle_112"
                        width="17.2"
                        height="7.93"
                        transform="translate(313.79 347.91)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_113"
                        width="84.95"
                        height="7.93"
                        transform="translate(313.79 333.74)"
                        fill="#fff"
                    />
                    <rect
                        id="Rectangle_114"
                        width="74.53"
                        height="7.93"
                        transform="translate(313.79 333.74)"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_115"
                        width="84.95"
                        height="7.93"
                        transform="translate(313.79 319.56)"
                        fill="#fff"
                    />
                    <rect
                        id="Rectangle_116"
                        width="34.4"
                        height="7.93"
                        transform="translate(313.79 319.56)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_117"
                        width="84.95"
                        height="7.93"
                        transform="translate(313.79 305.38)"
                        fill="#fff"
                    />
                    <rect
                        id="Rectangle_118"
                        width="58.54"
                        height="7.93"
                        transform="translate(313.79 305.38)"
                        fill="#707171"
                    />
                    <path
                        id="Path_145"
                        d="M126.13,314.69a13.64,13.64,0,0,1-6-15.79l-7.61-4.55a22.29,22.29,0,0,0,26.34,30.22l-3.71-8.13a13.44,13.44,0,0,1-9.02-1.75Z"
                        fill="#707171"
                    />
                    <path
                        id="Path_146"
                        d="M140.06,291.37a13.46,13.46,0,0,1,5.61,6.54l8.52-2.13a22.28,22.28,0,0,0-37.36-8l7.79,4.65a13.63,13.63,0,0,1,15.44-1.06Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_147"
                        d="M155.42,303.57l-9,2.28a13.49,13.49,0,0,1-4.12,7.21l3.74,8.19a22.37,22.37,0,0,0,9.42-17.68Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_148"
                        d="M231.5,224l-5.23,10.28-37.22-.23a8.75,8.75,0,0,0-8.78,9.37l4,45.08a8.74,8.74,0,0,0,8.67,8.12l84,.53a8.75,8.75,0,0,0,8.78-8.13l4.93-60.18a8.74,8.74,0,0,0-8.67-9.36l-42.67-.27A8.74,8.74,0,0,0,231.5,224Z"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_119"
                        width="16.47"
                        height="65.18"
                        transform="translate(185.252 254.366) rotate(-89.64)"
                        fill="#fff"
                    />
                    <path
                        id="Path_149"
                        d="M247.94,195.71l11.71,33.36a5.31,5.31,0,0,1-3.24,6.77L226.9,246.2a5.3,5.3,0,0,1-6.76-3.26l-15.3-43.57a5.3,5.3,0,0,1,3.25-6.76l19.27-6.77Z"
                        fill="url(#linear-gradient-5)"
                    />
                    <path
                        id="Path_150"
                        d="M250.26,192.22,262,225.58a5.3,5.3,0,0,1-3.24,6.77l-29.5,10.36a5.31,5.31,0,0,1-6.77-3.26L207.2,195.88a5.3,5.3,0,0,1,3.24-6.76l19.28-6.77Z"
                        fill="#fff"
                    />
                    <path id="Path_151" d="M250.26,192.22l-15.23,5.35-5.34-15.22Z" fill="#e3e2e3" />
                    <rect
                        id="Rectangle_120"
                        width="25.2"
                        height="3.33"
                        transform="translate(227.266 219.046) rotate(-19.34)"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_121"
                        width="25.2"
                        height="3.33"
                        transform="translate(229.258 224.736) rotate(-19.34)"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_122"
                        width="25.2"
                        height="3.33"
                        transform="translate(231.259 230.422) rotate(-19.34)"
                        fill="#707171"
                    />
                    <path
                        id="Path_152"
                        d="M225.37,221.46a1.67,1.67,0,1,1-2.12-1,1.67,1.67,0,0,1,2.12,1Z"
                        fill="#707171"
                    />
                    <path
                        id="Path_153"
                        d="M227.36,227.15a1.66,1.66,0,1,1-2.12-1,1.66,1.66,0,0,1,2.12,1Z"
                        fill="#707171"
                    />
                    <path
                        id="Path_154"
                        d="M229.36,232.84a1.66,1.66,0,1,1-2.12-1A1.66,1.66,0,0,1,229.36,232.84Z"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_123"
                        width="9"
                        height="9"
                        transform="translate(217.115 208.055) rotate(-19.34)"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_155"
                        d="M231.11,233.75l-5.68,11.18-40.49-.25a9.5,9.5,0,0,0-9.54,10.19l4.38,49.93a9.51,9.51,0,0,0,9.43,8.83l91.36.57a9.51,9.51,0,0,0,9.55-8.84L295.48,239a9.51,9.51,0,0,0-9.43-10.19l-46.4-.29a9.53,9.53,0,0,0-8.54,5.23Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_156"
                        d="M330.62,191.88l-16.25,31.49a5.32,5.32,0,0,1-7.17,2.3L279.35,211.3a5.32,5.32,0,0,1-2.27-7.18L298.3,163a5.32,5.32,0,0,1,7.16-2.28l18.2,9.39Z"
                        fill="url(#linear-gradient-6)"
                    />
                    <path
                        id="Path_157"
                        d="M334.11,190.72l-16.25,31.49a5.32,5.32,0,0,1-7.16,2.3l-27.86-14.38a5.31,5.31,0,0,1-2.27-7.17l21.23-41.13a5.31,5.31,0,0,1,7.15-2.29l18.2,9.39Z"
                        fill="#fff"
                    />
                    <path id="Path_158" d="M334.11,190.72l-14.37-7.42,7.41-14.37Z" fill="#dfdeee" />
                    <rect
                        id="Rectangle_124"
                        width="14.92"
                        height="9.02"
                        transform="translate(301.331 174.359) rotate(27.3)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_125"
                        width="31.3"
                        height="3.13"
                        transform="translate(295.709 185.251) rotate(27.3)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_126"
                        width="31.3"
                        height="3.13"
                        transform="translate(292.985 190.526) rotate(27.3)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_127"
                        width="31.3"
                        height="3.13"
                        transform="translate(290.261 195.792) rotate(27.3)"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_128"
                        width="31.3"
                        height="3.13"
                        transform="translate(287.546 201.057) rotate(27.3)"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_159"
                        d="M305.86,171.85a1.44,1.44,0,1,1-.62-1.93,1.44,1.44,0,0,1,.62,1.93Z"
                        fill="#707171"
                    />
                    <path
                        id="Path_160"
                        d="M310.59,174.29a1.44,1.44,0,1,1-.62-1.94,1.44,1.44,0,0,1,.62,1.94Z"
                        fill="#707171"
                    />
                    <path
                        id="Path_161"
                        d="M224.51,191.39A.56.56,0,0,1,224,191a27.047,27.047,0,0,1-1-2.78.57.57,0,0,1,.38-.73.58.58,0,0,1,.73.38,22.353,22.353,0,0,0,1,2.69.59.59,0,0,1-.31.76.62.62,0,0,1-.29.07Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_162"
                        d="M222.32,182.93a.59.59,0,0,1-.58-.51,34.623,34.623,0,0,1-.22-3.81c0-.71,0-1.43.07-2.14a.581.581,0,1,1,1.16.07c0,.69-.07,1.38-.07,2.07a32.132,32.132,0,0,0,.22,3.67.6.6,0,0,1-.51.65Zm.76-11.62h-.14a.59.59,0,0,1-.43-.71,31.251,31.251,0,0,1,1.74-5c.08-.19.17-.38.26-.57a.58.58,0,0,1,.77-.29.59.59,0,0,1,.28.78l-.25.55a30,30,0,0,0-1.67,4.86.59.59,0,0,1-.56.38ZM257.41,169a8,8,0,0,1-2.46-.4.583.583,0,1,1,.36-1.11,6.64,6.64,0,0,0,2.61.33,6.93,6.93,0,0,0,2.62-.77.58.58,0,0,1,.54,1A7.91,7.91,0,0,1,258,169Zm-6.85-3.88a.6.6,0,0,1-.48-.24,11.87,11.87,0,0,1-2.16-5.69.58.58,0,0,1,.52-.64.59.59,0,0,1,.64.52A10.61,10.61,0,0,0,251,164.2a.59.59,0,0,1-.13.82.63.63,0,0,1-.31.1Zm14.2-1.16a.57.57,0,0,1-.25-.06.58.58,0,0,1-.27-.78,9,9,0,0,0,.94-3.93v-.8a6,6,0,0,0-.09-.61.58.58,0,0,1,.48-.67.57.57,0,0,1,.67.48c0,.22.07.45.09.68s0,.62,0,.92a10.23,10.23,0,0,1-1,4.45.6.6,0,0,1-.57.36ZM228,160.75a.53.53,0,0,1-.34-.11.58.58,0,0,1-.13-.81,32.109,32.109,0,0,1,3.91-4.49.58.58,0,1,1,.8.84,31.718,31.718,0,0,0-3.77,4.33A.57.57,0,0,1,228,160.75Zm73.45-1.35a.59.59,0,0,1-.53-.35,31.307,31.307,0,0,0-2.75-5.05.594.594,0,1,1,1-.64,31.934,31.934,0,0,1,2.85,5.23.57.57,0,0,1-.31.76A.59.59,0,0,1,301.45,159.4ZM249.5,154a.59.59,0,0,1-.23-.05.58.58,0,0,1-.31-.76,17.31,17.31,0,0,1,3.34-5,.58.58,0,0,1,.85.79,16.47,16.47,0,0,0-3.12,4.69A.57.57,0,0,1,249.5,154Zm13.67-1a.58.58,0,0,1-.45-.21,13.26,13.26,0,0,0-4.37-3.46.59.59,0,0,1-.26-.78.57.57,0,0,1,.78-.26,14.46,14.46,0,0,1,4.75,3.76.58.58,0,0,1-.45.95Zm-26.76-.33a.56.56,0,0,1-.48-.26.58.58,0,0,1,.16-.81,32.383,32.383,0,0,1,5.25-2.81.6.6,0,0,1,.77.31.58.58,0,0,1-.32.76,31.61,31.61,0,0,0-5.06,2.71.55.55,0,0,1-.32.12Zm58.55-3a.63.63,0,0,1-.42-.17,29.511,29.511,0,0,0-4.39-3.69A.58.58,0,0,1,290,145a.59.59,0,0,1,.81-.15,30.651,30.651,0,0,1,4.56,3.83.57.57,0,0,1,0,.82.6.6,0,0,1-.37.23Zm-47.8-1.51a.58.58,0,0,1-.11-1.15,22.5,22.5,0,0,1,4.25-.42h0a12.453,12.453,0,0,1,1.73.08.582.582,0,0,1-.1,1.16c-.54,0-1.08-.07-1.63-.07h0a21.719,21.719,0,0,0-4,.39Zm10.07-2.79a.59.59,0,0,1-.49-.27.58.58,0,0,1,.18-.8l.69-.43a28.841,28.841,0,0,1,4.65-2.23.58.58,0,1,1,.41,1.08,29.589,29.589,0,0,0-4.46,2.15c-.23.13-.45.27-.66.41a.62.62,0,0,1-.32.15Zm28.12-2.26a.59.59,0,0,1-.23,0,29,29,0,0,0-5.48-1.68.581.581,0,1,1,.23-1.14,30.37,30.37,0,0,1,5.7,1.75.58.58,0,0,1,.31.76.57.57,0,0,1-.53.37Zm-17.24-1.89a.58.58,0,0,1-.1-1.15,32.471,32.471,0,0,1,5.49-.47h.5a.58.58,0,0,1,.57.59.56.56,0,0,1-.59.58h-.43a30.241,30.241,0,0,0-5.29.46Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_163"
                        d="M303.71,168a.59.59,0,0,1-.58-.52c-.1-.93-.25-1.88-.44-2.81a.57.57,0,0,1,.45-.69.58.58,0,0,1,.69.45,29.25,29.25,0,0,1,.46,2.93.58.58,0,0,1-.52.64Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_164"
                        d="M345.9,274.54h0a38.618,38.618,0,0,1-5.86-.73.58.58,0,0,1-.45-.68.59.59,0,0,1,.69-.46,37.2,37.2,0,0,0,5.68.71.58.58,0,1,1,0,1.16Zm5.81-.11a.58.58,0,1,1,0-1.16,47.25,47.25,0,0,0,5.68-.85.583.583,0,0,1,.24,1.14,49.91,49.91,0,0,1-5.82.87Zm-17.15-2.23a.778.778,0,0,1-.21,0,32.23,32.23,0,0,1-5.29-2.64.586.586,0,0,1,.61-1,30.317,30.317,0,0,0,5.1,2.54.59.59,0,0,1,.33.76.6.6,0,0,1-.54.34Zm28.5-.15a.58.58,0,0,1-.55-.39.59.59,0,0,1,.37-.74,52.112,52.112,0,0,0,5.35-2.11.58.58,0,0,1,.77.28.59.59,0,0,1-.29.77,51.994,51.994,0,0,1-5.46,2.16.579.579,0,0,1-.19.03Zm10.55-4.85a.58.58,0,0,1-.29-1.08c1.6-.95,3.23-2,4.83-3.14a.59.59,0,0,1,.81.14.57.57,0,0,1-.14.81c-1.62,1.15-3.28,2.23-4.91,3.19A.56.56,0,0,1,373.61,267.2Zm-48.88-1.09a.58.58,0,0,1-.39-.15,44.72,44.72,0,0,1-4.11-4.22.59.59,0,0,1,.89-.76,43.551,43.551,0,0,0,4,4.11.58.58,0,0,1-.38,1Zm58.38-5.59a.589.589,0,0,1-.37-1.04c1.43-1.16,2.9-2.43,4.37-3.78a.57.57,0,0,1,.82,0,.58.58,0,0,1,0,.82c-1.49,1.37-3,2.66-4.42,3.84a.64.64,0,0,1-.4.16Zm-66-3.17a.6.6,0,0,1-.48-.24c-1-1.42-2.05-3-3.25-4.85a.58.58,0,0,1,.17-.81.6.6,0,0,1,.81.18c1.19,1.87,2.22,3.4,3.22,4.8a.58.58,0,0,1-.13.81.55.55,0,0,1-.34.11Zm74.58-4.67a.62.62,0,0,1-.41-.17.6.6,0,0,1,0-.83c1.3-1.3,2.62-2.66,4-4.17a.58.58,0,0,1,.85.79c-1.41,1.52-2.74,2.9-4,4.21a.63.63,0,0,1-.44.17Zm-80.91-5.09a.58.58,0,0,1-.49-.28c-1-1.56-2-3.23-3.08-4.92a.59.59,0,0,1,.18-.81.58.58,0,0,1,.8.18c1.08,1.7,2.12,3.37,3.09,4.94a.59.59,0,0,1-.5.89Zm88.87-3.4a.58.58,0,0,1-.43-1c1.29-1.44,2.57-2.9,3.85-4.35a.581.581,0,1,1,.87.77c-1.28,1.45-2.56,2.91-3.86,4.36a.56.56,0,0,1-.43.22ZM304.5,237.8a.56.56,0,0,1-.48-.26c-1.22-1.77-2.33-3.29-3.41-4.66a.584.584,0,1,1,.92-.72c1.09,1.39,2.22,2.93,3.45,4.73a.58.58,0,0,1-.15.8.59.59,0,0,1-.33.11Zm102.84-2.33a.59.59,0,0,1-.43-1c1.28-1.45,2.57-2.9,3.88-4.33a.581.581,0,1,1,.86.78c-1.3,1.43-2.59,2.88-3.87,4.32A.6.6,0,0,1,407.34,235.47ZM263,229.27a.62.62,0,0,1-.38-.14.58.58,0,0,1-.06-.82,7.889,7.889,0,0,1,1.06-1,.58.58,0,0,1,.72.91,6.72,6.72,0,0,0-.9.86.59.59,0,0,1-.44.19Zm34.21-.53a.57.57,0,0,1-.4-.16l-.48-.45A11.8,11.8,0,0,0,292,225.9a.57.57,0,0,1-.38-.73.59.59,0,0,1,.73-.38,12.67,12.67,0,0,1,4.75,2.49c.17.15.33.3.5.47a.57.57,0,0,1,0,.82.55.55,0,0,1-.39.17Zm118-1.85a.57.57,0,0,1-.4-.16.58.58,0,0,1,0-.82c1.44-1.49,2.78-2.84,4.13-4.14a.58.58,0,1,1,.8.84c-1.33,1.28-2.67,2.62-4.09,4.1a.56.56,0,0,1-.46.18Zm-146-1a.59.59,0,0,1-.56-.41.58.58,0,0,1,.4-.72,34.88,34.88,0,0,1,5.79-1.15.58.58,0,1,1,.14,1.15,34.68,34.68,0,0,0-5.6,1.11.5.5,0,0,1-.18-.02Zm17.31-1.11h-.07a48.448,48.448,0,0,0-5.73-.35.57.57,0,0,1-.58-.58.58.58,0,0,1,.58-.58h0a46.621,46.621,0,0,1,5.87.36.58.58,0,0,1-.07,1.15Zm137.08-5.89a.57.57,0,0,1-.44-.2.58.58,0,0,1,.05-.82c1.52-1.32,3-2.57,4.54-3.71a.582.582,0,1,1,.7.93c-1.47,1.12-3,2.35-4.47,3.65a.57.57,0,0,1-.39.11Zm9.25-7a.58.58,0,0,1-.49-.26.57.57,0,0,1,.17-.8c1.52-1,3.07-1.91,4.6-2.75l.45-.23a.58.58,0,1,1,.54,1l-.43.24c-1.51.81-3,1.72-4.53,2.69a.56.56,0,0,1-.32.03Zm10.26-5.43a.58.58,0,0,1-.54-.36.59.59,0,0,1,.32-.76c1.79-.74,3.65-1.41,5.52-2a.58.58,0,0,1,.72.39.57.57,0,0,1-.38.72,52.556,52.556,0,0,0-5.42,2,.54.54,0,0,1-.23-.07ZM483,203.5a.32.32,0,0,1-.14,0c-1.85-.47-3.74-.86-5.64-1.16a.59.59,0,0,1-.49-.67.58.58,0,0,1,.67-.48,58.617,58.617,0,0,1,5.75,1.19.58.58,0,0,1,.41.71.57.57,0,0,1-.56.41Zm-28.8-.5a.59.59,0,0,1-.57-.46.57.57,0,0,1,.45-.69c1.9-.41,3.85-.73,5.78-1A.58.58,0,1,1,460,202c-1.9.22-3.81.54-5.68.93Zm17.34-1.27h0c-1.91-.12-3.84-.15-5.76-.1a.56.56,0,0,1-.59-.57.58.58,0,0,1,.56-.6c2,0,3.92,0,5.87.11a.58.58,0,0,1,.54.62.57.57,0,0,1-.62.49Z"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_129"
                        width="51.22"
                        height="46.32"
                        rx="3.3"
                        transform="matrix(0.858, -0.514, 0.514, 0.858, 337.864, 251.218)"
                        fill="url(#linear-gradient-7)"
                    />
                    <rect
                        id="Rectangle_130"
                        width="51.22"
                        height="46.32"
                        rx="3.3"
                        transform="matrix(0.858, -0.514, 0.514, 0.858, 339.028, 246.573)"
                        fill="#707171"
                    />
                    <path
                        id="Path_165"
                        d="M383,225.87l18.8,31.37a2.29,2.29,0,0,1-.8,3.15l-35.09,21a2.29,2.29,0,0,1-3.15-.77L344,249.28a2.31,2.31,0,0,1,.8-3.17l35.08-21A2.31,2.31,0,0,1,383,225.87Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_166"
                        d="M396.28,257.55l2.51,4.18L369.5,279.29l3.02-26.75,6.98,1.48Z"
                        fill="#707171"
                    />
                    <path
                        id="Path_167"
                        d="M398.59,251.83l3.24,5.41a2.29,2.29,0,0,1-.8,3.15L377.15,274.7,379.5,254l.68-6.06Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_168"
                        d="M367.21,247.52a7.85,7.85,0,1,1-10.77-2.7,7.85,7.85,0,0,1,10.77,2.7Z"
                        fill="#e3e2e3"
                    />
                    <rect
                        id="Rectangle_131"
                        width="43.867"
                        height="43.867"
                        rx="4.19"
                        transform="matrix(0.948, 0.319, -0.319, 0.948, 370.215, 160.503)"
                        fill="url(#linear-gradient-8)"
                    />
                    <rect
                        id="Rectangle_132"
                        width="43.76"
                        height="43.76"
                        rx="4.18"
                        transform="translate(373.471 158.251) rotate(18.66)"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_169"
                        d="M382.15,191.3c-.27-2.1-3.16-3.46-6.47-3s-5.77,2.45-5.51,4.55,3.16,3.45,6.47,3S382.41,193.39,382.15,191.3Z"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_133"
                        width="3.61"
                        height="17.04"
                        transform="translate(384.039 175.185) rotate(18.66)"
                        fill="#707171"
                    />
                    <ellipse
                        id="Ellipse_16"
                        cx="6.031"
                        cy="3.814"
                        rx="6.031"
                        ry="3.814"
                        transform="translate(384.084 189.674) rotate(-7.481)"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_134"
                        width="3.61"
                        height="17.04"
                        transform="translate(398.345 178.091) rotate(18.66)"
                        fill="#707171"
                    />
                    <path
                        id="Path_170"
                        d="M384.04,175.18l18.55,1.62-1.78,5.28-18.45-1.92Z"
                        fill="#707171"
                    />
                    <rect
                        id="Rectangle_135"
                        width="34.21"
                        height="34.21"
                        rx="4.15"
                        transform="translate(190.801 116.982) rotate(-28.9)"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_171"
                        d="M219.54,133.61A11.36,11.36,0,1,1,224,118.18a11.36,11.36,0,0,1-4.46,15.43Zm-10.07-18.23a9.46,9.46,0,1,0,12.87,3.71,9.46,9.46,0,0,0-12.87-3.71Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_172"
                        d="M208.12,121l5.6,10.14a.66.66,0,0,0,1.14,0l5.54-9.67a.63.63,0,0,0-.53-1L208.74,120a.65.65,0,0,0-.62,1Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_173"
                        d="M337.91,288.15a62.51,62.51,0,0,1-61-8.21l10.63-14.15C304.56,287.45,337.91,288.15,337.91,288.15Z"
                        fill="#707171"
                    />
                    <path
                        id="Path_174"
                        d="M297.56,260.94l-40.38-4.24,16.51,37.09Z"
                        fill="#707171"
                    />
                    <path
                        id="Path_175"
                        d="M247.92,124.82a53.4,53.4,0,0,1,41.23-32.68l2.4,14.93C268.12,104.72,247.92,124.82,247.92,124.82Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_176"
                        d="M288.57,116.13,315.12,93.8,282.51,81.97Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_177"
                        d="M214.2,49.66a16,16,0,0,0-2.42.2,25.17,25.17,0,0,0-47,4.06,14,14,0,0,0-17,13.64,7.49,7.49,0,0,0-7.49,7.49,7.72,7.72,0,0,0,.19,1.68h86A16.31,16.31,0,0,0,214.2,49.66Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_178"
                        d="M181.87,87.9h13.01V63.93h7.11L188.37,48.3,174.76,63.93h7.11Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_179"
                        d="M396.37,113l-1.2-3.55L394,113a19.3,19.3,0,0,1-9,10.72h0a19.24,19.24,0,0,1,9,10.72l1.2,3.55,1.2-3.55a19.16,19.16,0,0,1,9-10.72h0A19.22,19.22,0,0,1,396.37,113Z"
                        fill="#e3e2e3"
                    />
                    <path
                        id="Path_180"
                        d="M432.08,156.24l-.83-2.46-.84,2.46a13.35,13.35,0,0,1-6.23,7.44h0a13.29,13.29,0,0,1,6.23,7.43l.84,2.46.83-2.46a13.31,13.31,0,0,1,6.24-7.43h0a13.36,13.36,0,0,1-6.24-7.44Z"
                        fill="#e3e2e3"
                    />
                    <path id="Path_181" d="M138.75,119.02l12.74-4.39,3.77,24.61Z" fill="#e3e2e3" />
                    <path id="Path_182" d="M163.31,118.84l6.78,3.96-9.44,11Z" fill="#e3e2e3" />
                    <path id="Path_183" d="M131.82,134.28l3.34-7.1,11.8,8.41Z" fill="#e3e2e3" />
                    <circle
                        id="Ellipse_17"
                        cx="4.97"
                        cy="4.97"
                        r="4.97"
                        transform="translate(66.39 363.69)"
                        fill="#fff"
                        stroke="#e2e2e2"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                    />
                    <circle
                        id="Ellipse_18"
                        cx="10.77"
                        cy="10.77"
                        r="10.77"
                        transform="translate(95.29 376.19)"
                        fill="#fff"
                        stroke="#e2e2e2"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                    />
                    <path
                        id="Path_184"
                        d="M332.16,120.4h-6.09v-6.08a.76.76,0,0,0-.76-.76h0a.78.78,0,0,0-.78.76v6.08h-6.08a.78.78,0,0,0-.76.78.76.76,0,0,0,.76.76h6.08V128a.78.78,0,0,0,.78.76.76.76,0,0,0,.76-.76h0v-6.09h6.09a.77.77,0,0,0,0-1.54Z"
                        fill="#e2e2e2"
                        stroke="#e2e2e2"
                        strokeMiterlimit="10"
                        strokeWidth="0.75"
                    />
                    <path
                        id="Path_185"
                        d="M357.72,86.64h-10v-10a1.24,1.24,0,0,0-1.24-1.24h0a1.27,1.27,0,0,0-1.27,1.24v10h-10a1.255,1.255,0,0,0,.05,2.51h10v10a1.27,1.27,0,0,0,1.27,1.24,1.24,1.24,0,0,0,1.24-1.24h0v-10h10A1.24,1.24,0,0,0,359,87.91a1.27,1.27,0,0,0-1.28-1.27Z"
                        fill="#e2e2e2"
                        stroke="#e2e2e2"
                        strokeMiterlimit="10"
                        strokeWidth="0.75"
                    />
                </g>
            </g>
        </SVGIcon>
    );
}
